<template>
  <div class="bg-white">
    <div class="pt-3">
      <ul>
        <li v-if="tab == 'available'" class="pl-2">
          <el-checkbox class="mr-2" v-model="allChecked" />
        </li>
        <li :class="[item.w,'font-weight-bold']" v-for="(item,index) in listArr" :key="index">{{item.title}}</li>
      </ul>
      <p v-if="RebateInfo.count<=0" class="mt-5 h5">未查询到数据！</p>
      <div v-else class="border-top mt-5">
        <ul v-for="(rebateItem,index) in RebateInfo.data" :key="index" class="border-bottom ulheight">
          <li v-if="tab == 'available'" class="pl-2">
            <el-checkbox v-model="rebateItem.checked" class="mr-2" />
          </li>
          <li class="w-13">
            <el-popover placement="right" trigger="hover">
                {{rebateItem.title}}<span slot="reference">{{rebateItem.title | formatString(13)}}</span>
            </el-popover>
          </li>
          <li class="w-13">
            <div v-if="rebateItem.order_style == 6">景区返利</div>
            <div v-else><div>{{rebateItem.type == 1 ? '限时优惠' : '限时抢购'}}</div></div>
            <div>{{rebateItem.date_in | formatTimestamp()}}</div>
          </li>
          <li class="w-13">{{rebateItem.occupant_name + ' / '+ rebateItem.occupant_mobile}}</li>
          <li class="w-7">{{rebateItem.num}}</li>
          <li class="w-13">&yen;{{(Number(rebateItem.price_pay) / 100).toFixed(2)}}</li>
          <li class="w-13">&yen;{{rebateItem.parent_money}}</li>
          <li class="w-13">{{rebateItem.time | formatTimestamp()}}</li>
          <li class="w-7 text-success" v-if="rebateItem.is_put_forward === 0">{{rebateItem.is_put_forward | rebateState()}}</li>
          <li class="w-7 text-muted" v-if="rebateItem.is_put_forward === 2">{{rebateItem.is_put_forward | rebateState()}}</li>
          <li class="w-7 text-login" v-if="rebateItem.is_put_forward === 1">{{rebateItem.is_put_forward | rebateState()}}</li>
          <li class="w-7 text-link" @click="$router.push({name:'VocationQR',query:{id:rebateItem.id,type:rebateItem.order_style}})">查看</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'DisplayList',
    props: ['tab'],
    computed: {
      ...mapState(['RebateInfo']),
    },
    data() {
      return {
        allChecked: false,
        listArr: [
          {w: 'w-13', title: '产品名称'},
          {w: 'w-13', title: '产品类型/出行日期'},
          {w: 'w-13', title: '联系人/电话'},
          {w: 'w-7', title: '数量'},
          {w: 'w-13', title: '付款金额'},
          {w: 'w-13', title: '佣金金额'},
          {w: 'w-13', title: '购买时间'},
          {w: 'w-7', title: '状态'},
          {w: 'w-7', title: '操作'},
        ]
      }
    },
    watch: {
      //可提现列表时全选当前页
      'allChecked': 'setAllChecked',
      'RebateInfo.data'() {
        if (this.RebateInfo.data) {
          let ln = this.RebateInfo.data.length
          let lg = this.RebateInfo.data.filter(v => v.checked)
          if (ln == lg.length) this.allChecked = true
          else this.allChecked = false
        }
      }
    },
    filters: {
      rebateState: val => {
        switch (val) {
          case 0: return '可提返现';
          case 1: return '已提返现';
          case 2: return '冻结中';
        }
      }
    },
    methods: {
      setAllChecked () {
        let list = this.RebateInfo.data;
        list.forEach(v => {
            v.checked = this.allChecked;
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .ulheight{
    overflow: hidden;
  }
  li {
    float: left;
    background: #fff;
    padding: 10px 0;
  }

  .w-13 {
    width: 12%;
  }

  .w-7 {
    width: 7%;
  }
</style>
